import RandomComponentWithHeadline from './RandomComponentWithHeadline';

export default RandomComponentWithHeadline;
